export const addEditPetValidation = {
  name: [{ required: true, message: 'Name is required!' }],
  breed: [{ required: true, message: 'Breed is required!' }],
  color: [{ required: true, message: 'Color is required!' }],
  tagExpirationDate: [{ required: true, message: 'Shots expiration date is required!' }],
  chipNumber: [{ required: true, message: 'Chip number is required!' }],
  tag: [{ required: true, message: 'Tag is required!' }],
  addressId: [{ required: true, message: 'Address is required!' }],
};
